export function getStarterItemsQueue(starterItems) {
  const feedbackViews =
    starterItems.feedback_views.length > 0 ? ['Creating custom feedback views...'] : []

  const reportViews =
    starterItems.report_views.length > 0 ? ['Creating custom reports views...'] : []

  return [...feedbackViews, ...reportViews, 'Creating checklist items...']
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingLoading/utils.js